var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChartUp02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 42H9.2C8.07989 42 7.51984 42 7.09202 41.782C6.71569 41.5903 6.40973 41.2843 6.21799 40.908C6 40.4802 6 39.9201 6 38.8V6M42 14L31.1314 24.8686C30.7354 25.2646 30.5373 25.4627 30.309 25.5368C30.1082 25.6021 29.8918 25.6021 29.691 25.5368C29.4627 25.4627 29.2646 25.2646 28.8686 24.8686L25.1314 21.1314C24.7354 20.7354 24.5373 20.5373 24.309 20.4632C24.1082 20.3979 23.8918 20.3979 23.691 20.4632C23.4627 20.5373 23.2646 20.7354 22.8686 21.1314L14 30M42 14H34M42 14V22",
    stroke: "#394049",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartUp02);
export default __webpack_public_path__ + "static/media/line-chart-up-02.c3154d01ffe16af914df1c62b3a2e8ca.svg";
export { ForwardRef as ReactComponent };